import { render, staticRenderFns } from "./MaterialScienceManagement.vue?vue&type=template&id=a6e9677e&scoped=true"
import script from "./MaterialScienceManagement.vue?vue&type=script&lang=js"
export * from "./MaterialScienceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e9677e",
  null
  
)

export default component.exports